import template from './dateFormElement.html';
import controller from './dateFormElement.controller';
import './dateFormElement.scss';

let dateFormElementComponent = {
  restrict: 'E',
  bindings: {
    label: '@',
    value: '='
  },
  template,
  controller
};

export default dateFormElementComponent;
